module.exports = __webpack_public_path__ + "img/隐藏.b223071a.png";